import { motion } from 'framer-motion';
import { FiCheck, FiArrowRight } from 'react-icons/fi';
import { useAuth } from '../../../context/AuthContext';
import { userService } from '../../../services/user.service';
import { useState } from 'react';

const COMPLETE_FEATURES = [
  {
    title: 'Trial Started',
    description: '14 days of full access',
    emoji: '🎉'
  },
  {
    title: 'Personalized Setup',
    description: 'Everything is ready for you',
    emoji: '✨'
  },
  {
    title: 'Track Progress',
    description: 'Monitor your journey',
    emoji: '📈'
  }
];

const CompleteStep = ({ onNext }) => {
  const { user } = useAuth();
  const [initializing, setInitializing] = useState(false);
  const [error, setError] = useState('');

  const handleComplete = async () => {
    setInitializing(true);
    setError('');

    try {
      // Initialize trial period
      await userService.initializeTrial(user.uid);
      onNext();
    } catch (err) {
      console.error('Error initializing trial:', err);
      setError('Failed to start your trial. Please try again.');
    } finally {
      setInitializing(false);
    }
  };

  return (
    <motion.div
      className="onboarding-step complete-step"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
    >
      <div className="complete-content">
        <div className="complete-header">
          <motion.div 
            className="success-icon"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 500 }}
          >
            <FiCheck />
          </motion.div>
          <h2>Welcome Aboard!</h2>
          <p className="step-description">
            Your journey begins now
          </p>
        </div>

        <div className="complete-features">
          {COMPLETE_FEATURES.map((feature, index) => (
            <motion.div
              key={index}
              className={`complete-feature ${index === 0 ? 'highlight' : ''}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 + (index * 0.1) }}
            >
              <span className="feature-emoji">{feature.emoji}</span>
              <div className="feature-text">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {error && <div className="notification-error">{error}</div>}

        <motion.button
          className="onboarding-btn complete-btn"
          onClick={handleComplete}
          disabled={initializing}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          {initializing ? 'Starting trial...' : 'Go to Dashboard'}
          <FiArrowRight />
        </motion.button>
      </div>
    </motion.div>
  );
};

export default CompleteStep; 